(async () => {
  if (window.innerWidth > 1150) {
    let INITIALIZED = false;
    const miniCartContainer = document.querySelector('.js-mini-cart-container');
    miniCartContainer.addEventListener('mouseenter', async () => {
      if (!INITIALIZED) {
        INITIALIZED = true;
        const miniCartSection = await getMiniCart();
        const miniCartSectionElement = document.createElement('div');
        miniCartSectionElement.innerHTML = miniCartSection;
        const miniCartElement = miniCartSectionElement.querySelector('.mini-cart');
        if (Array.from(miniCartElement.querySelectorAll('.mini-cart__item')).length === 0) {
          return;
        }
        if (miniCartContainer.querySelector('.mini-cart')) {
          miniCartContainer.querySelector('.mini-cart').remove();
        }
        miniCartContainer.appendChild(miniCartElement);
      }
    });

    async function getMiniCart() {
      return fetch('/?sections=mini-cart')
        .then((res) => res.json())
        .then((res) => res['mini-cart']);
    }
  }
})();
